// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapersSidebar-cls1_rvu","cls2":"RelatedPapersSidebar-cls2_bYC RelatedPapersSidebar-cls1_rvu"};